import React, { useEffect, useState } from 'react';
import './ForgotPassword.css';

import MapItButton from '../../Common/MapItButton/MapItButton';
import {TailSpin} from 'react-loader-spinner';

import { useNavigate } from 'react-router-dom';

import User from "../../../Models/User";

import eye_crossed from "../../../Assets/eye_icon_crossed.png";
import eye_icon from "../../../Assets/eye_icon.png";

import * as Loader from 'react-spinners';

const prod_host = "https://server.mapit.cc";


const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  let navigate = useNavigate();

  const title = "Reset Password";
  const titleMsg = "Enter the email used to register your account";

  const onForgotPassword = () => {
    console.log('in forgot password function')
    console.log(email);
    setLoading(true);
    fetch(`${prod_host}/forgot-password`, {
      method: 'post',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({
        email: email,
      })
      })
      .then(response => response.json())
      .then(result => {
        if (result === "success") {
          const userMsg = "Email sent with reset link.";
          console.log(userMsg);
        } else {
          console.log(`Debug Log: Error occurred during login: ${result}`);
          console.log(result);
        }
        setLoading(false);
        navigate("/login");
      })
      .catch((error) => {
        console.log(`error occurred from server`)
        console.log(error);
        setLoading(false);
      });
  }
  
  const onEmailChange = (email) => {
    // check input before setting
    setEmail(email.target.value);
  }

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
        onForgotPassword();    
    }
  }

  return (
    <div className='container'>
      {/* <div className="container-left">
      </div> */}
      <div className="container-right">
        <div className="login-container">
          <div className="login-text">
            <p className="login-text-welcome">{title}</p>
            <p className="login-text-message">{titleMsg}</p>
          </div>
          <div className='email-input-div'>
            <input
              type="email"
              className="email-input-login"
              placeholder={"Email"}
              onChange={onEmailChange}
              selectionColor={'#34666F'}
              keyboardType={'email-address'}
              onKeyDown={handleKeyDown}
            />
          </div>
          <div className="login-button-div">
            <MapItButton onSubmit={onForgotPassword} className="login-mapitButton" text={"Reset Password"}></MapItButton>
          </div>
        </div>
        { loading &&
          <Loader.DotLoader
          color="#FCC81A"
          loading={loading}
          cssOverride={{position: "absolute", borderColor: "#FCC81A", zIndex: 1}}
          size={48}
          aria-label="Loading Spinner"
          data-testid="loader"
          />
      }
      </div>
    </div>
  );
}

export default ForgotPassword;